import React from "react";
import Link from "gatsby-link";
import Image from "./image";

import calloutMaui from "../../../static/images/photos-callout-maui.jpg";
import calloutMaui2019 from "../../../static/images/photos-callout-maui2019.jpg";
import calloutMaui2021 from "../../../static/images/photos-callout-maui2021.jpg";
import calloutCancun from "../../../static/images/photos-callout-cancun.jpg";
import calloutCancun2020 from "../../../static/images/photos-callout-cancun2020.jpg";
import calloutCancun2021 from "../../../static/images/photos-callout-cancun2021.jpg";
import calloutKauai2019 from "../../../static/images/photos-callout-kauai2019.jpg";
import calloutKauai2021 from "../../../static/images/photos-callout-kauai2021.jpg";

const images = {
  "callout-maui": calloutMaui,
  "callout-maui2019": calloutMaui2019,
  "callout-maui2021": calloutMaui2021,
  "callout-cancun": calloutCancun,
  "callout-cancun2020": calloutCancun2020,
  "callout-cancun2021": calloutCancun2021,
  "callout-kauai2019": calloutKauai2019,
  "callout-kauai2021": calloutKauai2021,
};

export default ({ trip }) => (
  <div className="photos-callout">
    <div className="wrap">
      <Image
        className={`side-img side-img-${trip}`}
        src={images[`callout-${trip}`]}
        alt=""
      />
      <p>
        <Link to={`/${trip}/gallery/`}>
          See Photos
          <i className="fa fa-angle-right" />
        </Link>
      </p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/partials/photos-callout.js